import { render, staticRenderFns } from "./driver-detail-driver-info-value.vue?vue&type=template&id=3a9aa0c1"
import script from "./driver-detail-driver-info-value.vue?vue&type=script&lang=js"
export * from "./driver-detail-driver-info-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports